import { headers, dataTypes } from 'constants/tableColumns';

/**
 * Table header names
 * Ref: https://synpulse.atlassian.net/browse/US-57
 */
export const detailedViewTable = [
    {
        i: 1,
        w: '8%',
        th: headers.tradeDate,
        prop: 'tradeDate',
        type: dataTypes.string
    },
    {
        i: 2,
        w: '8%',
        th: headers.orderId,
        prop: 'orderId',
        type: dataTypes.string
    },
    {
        i: 3,
        w: '8%',
        th: headers.portfolioId,
        prop: 'portfolioId',
        type: dataTypes.string
    },
    { i: 4, w: '6%', th: headers.rm, prop: 'rm', type: dataTypes.string },
    {
        i: 5,
        w: '8%',
        th: headers.rmGroup,
        prop: 'rmGroup',
        type: dataTypes.string
    },
    {
        i: 6,
        w: '8%',
        th: headers.rmRegion,
        prop: 'rmRegion',
        type: dataTypes.string
    },
    {
        i: 7,
        w: '8%',
        th: headers.vcStatus,
        prop: 'vcStatus',
        type: dataTypes.string
    },
    {
        i: 8,
        w: '8%',
        th: headers.orderInitiated,
        prop: 'orderInitiated',
        type: dataTypes.string
    },
    {
        i: 9,
        w: '8%',
        th: headers.instrumentSubType,
        prop: 'instrumentSubType',
        type: dataTypes.string
    },
    {
        i: 10,
        w: '14%',
        th: headers.instrumentName,
        prop: 'instrumentName',
        type: dataTypes.string
    },
    {
        i: 11,
        w: '6%',
        th: headers.prmAlert,
        prop: 'prmAlert',
        type: dataTypes.string
    },
    {
        i: 12,
        w: '6%',
        th: headers.crAlert,
        prop: 'crAlert',
        type: dataTypes.string
    }
];
